import { Injectable } from '@angular/core';
import { Newsletter, NewsletterStatus } from '../../domain/models/newsletter.model';
import { NewsletterInput } from '../../domain/models/newsletter-input.model';
import { CreateNewsletterRequestDto, NewsletterDto } from '../dtos/newsletter.dto';

@Injectable()
export class NewsletterMapper {
  public toNewsletter(dto: NewsletterDto): Newsletter {
    return {
      id: dto.Id,
      organizationId: dto.OrganizationId,
      title: dto.Title,
      summary: dto.Summary,
      bodyText: dto.BodyText,
      url: dto.Url ?? null,
      status: dto.Status as NewsletterStatus,
      publishedAtUtc: dto.PublishedAtUtc ?? null,
      pushCampaignId: dto.PushCampaignId ?? null,
      createdAtUtc: dto.CreatedAtUtc,
      updatedAtUtc: dto.UpdatedAtUtc,
    };
  }

  public toCreateRequest(input: NewsletterInput): CreateNewsletterRequestDto {
    return {
      Title: input.title,
      Summary: input.summary,
      BodyText: input.bodyText,
      Url: input.url,
    };
  }
}
